export default {
	PRODUCT_SETS: 'Product sets',
	PRODUCT_INGREDIENTS: 'Ingredients',
	DISCOUNTS: 'Discounts',
};